import { WorkbookDesignTemplate } from './WorkbookCoverDesignTemplate'

export class CustomPrintDesignTemplate extends WorkbookDesignTemplate {}
